module.exports = __webpack_public_path__ + "assets/img/ercode.270a1950.jpg";